import { crush, omit } from 'radash';

import { Cable } from 'models';

const CableHelpers = {
    mapFieldsToConnection: (cable: Cable) => {
        const crushed: Record<string, any> = crush({
            cableId: cable.id,
            ...omit(cable.electrical, ['operatingVoltage', 'ports']),
            ...cable.mechanical,
            ...cable.environmental,
            'voltage': {
                max: cable.electrical.operatingVoltage.betweenLines.value,
                unit: cable.electrical.operatingVoltage.betweenLines.unit,
            },
            conductorMaterial: cable.mechanical.conductorMaterial,
        });

        // remove null and undefined values
        const cleaned = Object.keys(crushed).reduce(
            (acc, key) => {
                if (crushed[key] !== null && crushed[key] !== undefined) {
                    acc[key] = crushed[key];
                }
                return acc;
            },
            {} as Record<string, any>,
        );

        return cleaned;
    },
};

export { CableHelpers };
